import { MapPin, X } from "lucide-react";
import { addressLabel, addressSummary } from "@/lib/addressBook";

/**
 * AddressBook — horizontal strip of the customer's previously used delivery
 * addresses (from localStorage). Clicking a chip fills the checkout form,
 * clicking the ✕ deletes just that saved entry.
 */
export default function AddressBook({ addresses, onPick, onRemove }) {
  if (!addresses || addresses.length === 0) return null;
  return (
    <section data-testid="address-book" className="mb-6">
      <div className="label-xs text-espresso-light mb-3">Recent addresses</div>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
        {addresses.map((a) => (
          <div
            key={a.id}
            data-testid={`saved-address-${a.id}`}
            className="group relative min-w-[220px] max-w-[260px] border border-line bg-ivory-100/50 hover:border-gold transition-colors cursor-pointer"
          >
            <button
              type="button"
              onClick={() => onPick(a)}
              className="w-full text-left p-4"
              data-testid={`pick-address-${a.id}`}
            >
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-gold mt-0.5 flex-shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="text-sm text-espresso font-medium truncate">{addressLabel(a)}</div>
                  <div className="text-xs text-espresso-light mt-1 line-clamp-2">{addressSummary(a)}</div>
                  {a.lat && a.lng && (
                    <div className="mt-2 inline-flex items-center gap-1 label-xs text-gold-hover">
                      <span className="inline-block h-1 w-1 rounded-full bg-gold" />
                      Pin saved
                    </div>
                  )}
                </div>
              </div>
            </button>
            <button
              type="button"
              onClick={() => onRemove(a.id)}
              aria-label="Remove address"
              data-testid={`remove-address-${a.id}`}
              className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 focus:opacity-100 text-espresso-light hover:text-rose-600 transition-opacity"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
